import React, { useEffect, useState, useContext } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import axios from 'axios';
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
} from "@material-ui/core";


import HistoryIcon from '@material-ui/icons/History';
import CloseIcon from '@material-ui/icons/Close';

import { PageContext } from "../../../contexts/PageContext";
import { UserContext } from "../../../contexts/UserContext";
import { formatDate, formatDateTime } from '../../../functions/GlobalHelpers';

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  descriptionPaper: theme.descriptionPaper,
}));

export default function CreditHistoryDialog(
  {
    credit
  }) {
  const theme = useTheme();
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [historyActions, setHistoryActions] = useState([]);

  const userContext = useContext(UserContext);
  const pageContext = useContext(PageContext);
  useEffect(() => {
    if (open) {
      // reload every time dialog is opened
      getHistory();
    }
  }, [open]);

  const getHistory = () => {
    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/credithistory/${credit.id}`,
      method: 'get',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        setHistoryActions(res.data);
      })
      .catch((err) => { console.log(err); });
  }



  return (
    <>
      {["administrator"].includes(userContext.user.role) && (<Button
        variant="outlined"
        startIcon={<HistoryIcon />}
        onClick={() => {
          setOpen(true);
        }}
      >
        Verlauf anzeigen
      </Button>)}
      <Dialog
        onClose={() => { setOpen(false) }}
        open={open}
        fullWidth={true}
        maxWidth="sm">
        <DialogTitle>
          Verlauf des Antrags
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {historyActions.length === 0 &&
            <Typography variant="body2">Bisher sind noch Einträge vorhanden.</Typography>
          }
          {historyActions.map((action) => (
            <div key={action.id}>
              <Typography variant="caption">
                {formatDateTime(action.created_date, true)}:
              </Typography>
              <Typography variant="body2">
                {
                  // strip all [...] from action_description
                  action.action_description.replace(/\[.*?\]/g, "")
                }
              </Typography>
              <br />
            </div>
          ))}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            color="primary"
            variant="contained"
            autoFocus>
            ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
